module.exports = __webpack_public_path__ + "static/media/056.3d935ae6.jpg";